type MockVehicle = {
  id: number;
  year: number;
  make: string;
  model: string;
  value: number;
  vin: string;
  hasIdCard?: boolean;
};

type MockVehicleWithoutId = Omit<MockVehicle, "id">;

export function createVehiclesMap<T extends string>(obj: Record<T, MockVehicleWithoutId>) {
  let id = 100;
  const objWithId = Object.entries<MockVehicleWithoutId>(obj).map(([key, value]) => [key, { ...value, id: id++ }]);

  return Object.fromEntries(objWithId) as Record<T, MockVehicle>;
}
